/** @format */

import React, { FunctionComponent, useEffect, useState } from 'react';
import { TableBody, TableCell, TableHead } from '@material-ui/core';
import Order from '../../interfaces/forms/Order';
import Filter from '../../interfaces/forms/Filter';
import TableRow from '@material-ui/core/TableRow';
import I18n from '../../components/Translate/I18n';
import TableHeaderContentCell from '../../components/Table/TableHeaderContentCell';
import PlatformUser from '../../interfaces/platform/PlatformUser';
import EditButton from '../../components/Buttons/EditButton';
import DeleteButton from '../../components/Buttons/DeleteButton';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';
import RemoveCertificatesButton from '../../components/Buttons/RemoveCertificatesButton';
import RefreshButton from '../../components/Buttons/RefreshButton';
import BlockButton from '../../components/Buttons/BlockButton';
import OPL_STYLE from '../../assets/themes/OPL/OplStyle';
import PlatformUserDefinedRolesInterface from '../../interfaces/platform/PlatformUserDefinedRolesInterface';
import { DateHelperTs } from '../../helpers/DateHelperTs';
import moment from 'moment';
import { DateHelper } from '../../helpers/DateHelper';

export type PlatformUserListItemType = {
    classes: any;
    platformUsers: Array<PlatformUser> | null;
    userPermissionGroups: Array<PlatformUserDefinedRolesInterface> | null;
    // viewCallback: (iri: { uri: string }, event: any) => void;
    firstLoad: () => void;
    setActiveRow: (id: number) => void;
    activeRow: number;
    updateOrderList: (orders: Array<Order>) => void;
    updateFilterList: (filters: Array<Filter>) => void;
    filters: Array<Filter>;
    orders: Array<Order>;
    editCallback: (data: { uri: string }) => void;
    deleteCallback: (data: { uri: string }) => void;
    blockCallback: (data: { uri: string }) => void;
    unblockCallback: (data: { uri: string }) => void;
    discardCertificatesCallback: (data: any) => void;
};

export const PlatformUserListTable: FunctionComponent<PlatformUserListItemType> = ({
    platformUsers,
    classes,
    // viewCallback,
    updateOrderList,
    updateFilterList,
    setActiveRow,
    activeRow,
    firstLoad,
    filters,
    orders,
    editCallback,
    deleteCallback,
    blockCallback,
    unblockCallback,
    discardCertificatesCallback,
    userPermissionGroups,
}): React.ReactElement => {
    const tableStickyHeader = { root: classes.tableStickyHeader };
    const tableControlStickyHeader = { root: classes.tableControlStickyHeader };
    const tableStickyCommand = { root: classes.tableStickyCommand };
    const tableCellRoot = { root: classes.tableCellRoot };
    const tableRowRoot = { root: classes.tableRowRoot };
    const [adminRoleIds, setAdminRoleIds] = useState<Array<number>>([]);
    const [rolesApi, setRolesApi] = useState<any>(null);

    const checkIsAdmin = (platformUserDefinedRoleId: number | null | undefined): boolean => {
        if (platformUserDefinedRoleId) {
            return adminRoleIds.includes(platformUserDefinedRoleId);
        } else {
            return false;
        }
    };

    useEffect(() => {
        if (userPermissionGroups) {
            const ids: Array<number> = [];
            const r: Array<{ value: number, name: string }> = [];
            userPermissionGroups.map((el: PlatformUserDefinedRolesInterface) => {
                if (el.adminRole) {
                    ids.push(el.id);
                }
                r.push({value: el.id, name: el.mainname});
            });

            setRolesApi(r);
            setAdminRoleIds(ids);
        }
    }, [userPermissionGroups]);


    if (!rolesApi) {
        return <div></div>
    }

    return (
        <React.Fragment>
            <TableHead>
                <TableRow>
                    <TableCell classes={tableStickyCommand} padding="none" align="left">
                        <TableHeaderContentCell textAlign="left" title="general:common.commands" showSort={false}
                                                onlyFilter={false}/>
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="platform_user:h.id"
                            fieldName="id"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="number"
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="platform_user:h.username"
                            fieldName="username"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="string"
                            prependMaxLengthRequirement={9}
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="platform_user:h.name"
                            fieldName="personName"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="string"
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="platform_user:h.email"
                            fieldName="email"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="string"
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="platform_user:h.permission_group"
                            fieldName="permissionGroupId"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="select"
                            filters={filters}
                            sort={orders}
                            elementList={rolesApi}
                            selectComponent={'headerCheckBoxSimpleList'}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                    {process.env.REACT_APP_HIDE_DOMAIN !== 'true' && (
                        <TableCell classes={tableStickyHeader} padding="none" align="left">
                            <TableHeaderContentCell
                                textAlign="left"
                                title="platform_user:h.domain_user"
                                fieldName="allowGenericLogin"
                                showSort={true}
                                onlyFilter={false}
                                defaultDirection="desc"
                                searchFieldType="select"
                                selectComponent="headerBooleanCheckBoxSelectList"
                                filters={filters}
                                sort={orders}
                                updateOrderList={updateOrderList}
                                updateFilterList={updateFilterList}
                                searchActionCallback={firstLoad}
                            />
                        </TableCell>
                    )}
                    {process.env.REACT_APP_HIDE_DOMAIN !== 'true' && (
                        <TableCell classes={tableStickyHeader} padding="none" align="left">
                            <TableHeaderContentCell
                                textAlign="left"
                                title="platform_user:h.certificate_valid_to"
                                fieldName="certificateValidTo"
                                showSort={true}
                                onlyFilter={false}
                                defaultDirection="asc"
                                searchFieldType="date"
                                dateFormat="RRRR-MM-DD"
                                appendAutomaticTimeToBeforeAfterDate={true}
                                dateFromTo={true}
                                filters={filters}
                                sort={orders}
                                breakLine={true}
                                updateOrderList={updateOrderList}
                                updateFilterList={updateFilterList}
                                searchActionCallback={firstLoad}
                                nullable={false}
                            />
                        </TableCell>
                    )}
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="platform_user:h.password_last_changed"
                            fieldName="passwordLastChanged"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="asc"
                            searchFieldType="date"
                            dateFormat="RRRR-MM-DD"
                            appendAutomaticTimeToBeforeAfterDate={true}
                            dateFromTo={true}
                            filters={filters}
                            sort={orders}
                            breakLine={true}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                            nullable={false}
                        />
                    </TableCell>

                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="platform_user:h.password_expiry_date"
                            fieldName="passwordExpiryDate"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="asc"
                            searchFieldType="date"
                            dateFormat="RRRR-MM-DD"
                            appendAutomaticTimeToBeforeAfterDate={true}
                            dateFromTo={true}
                            filters={filters}
                            sort={orders}
                            breakLine={true}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                            nullable={false}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="platform_user:h.account_expiration"
                            fieldName="accountExpiration"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="asc"
                            searchFieldType="date"
                            dateFormat="RRRR-MM-DD"
                            appendAutomaticTimeToBeforeAfterDate={true}
                            dateFromTo={true}
                            filters={filters}
                            sort={orders}
                            breakLine={true}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                            nullable={false}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="platform_user:h.account_blocked"
                            fieldName="accountBlocked"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="select"
                            selectComponent="headerBooleanCheckBoxSelectList"
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="platform_user:h.account_deleted"
                            fieldName="deleted"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="select"
                            selectComponent="headerBooleanCheckBoxSelectList"
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="platform_user:h.waiting_for_single_login_password"
                            fieldName="singleLoginPassword"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="select"
                            selectComponent="headerBooleanCheckBoxSelectList"
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="platform_user:h.created_by_platform_user"
                            fieldName="createdByPlatformUser.username"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="string"
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="platform_user:h.system_user"
                            fieldName="systemAccount"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="select"
                            selectComponent="headerBooleanCheckBoxSelectList"
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {platformUsers?.map((item: PlatformUser) => {
                    let rowActiveColor = 'white';
                    if (activeRow === item.id) {
                        rowActiveColor = OPL_STYLE.TABLE.ACTIVE_ROW;
                    }
                    const passwordExpiration: any =
                        item.passwordLastChanged && item.passwordExpiration ? DateHelperTs.convertToMoment(item.passwordLastChanged) : null;
                    let passwordExpiry;
                    if (passwordExpiration && typeof item.passwordExpiration !== 'undefined') {
                        passwordExpiry = DateHelperTs.addDaysToDate(passwordExpiration, item.passwordExpiration);
                    }
                    return (
                        <TableRow
                            classes={tableRowRoot}
                            key={'key' + item.id}
                            hover
                            onClick={(): void => {
                                setActiveRow(item.id);
                            }}
                            style={{ backgroundColor: rowActiveColor }}
                        >
                            <TableCell classes={tableControlStickyHeader} padding="none" align="left">
                                {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_USER_ACCOUNT_ADMIN) && (
                                    <>
                                        <EditButton
                                            callback={editCallback}
                                            callbackParam={{ uri: item['@id'] }}
                                            tooltipTitle="platform_user:a.edit_user"
                                            tooltipPlacement="bottom-start"
                                        />
                                        {!checkIsAdmin(item.permissionGroupId) && (
                                            <DeleteButton
                                                callback={deleteCallback}
                                                callbackParam={{ uri: item['@id'] }}
                                                tooltipTitle="platform_user:a.delete_user"
                                                tooltipPlacement="bottom-start"
                                            />
                                        )}
                                        {!item.accountBlocked && (
                                            <BlockButton
                                                callback={blockCallback}
                                                callbackParam={{ uri: item['@id'] }}
                                                tooltipTitle="platform_user:a.block_user"
                                                tooltipPlacement="bottom-start"
                                            />
                                        )}
                                        {item.accountBlocked && (
                                            <RefreshButton
                                                callback={unblockCallback}
                                                callbackParam={{ uri: item['@id'] }}
                                                tooltipTitle="platform_user:a.unblock_user"
                                                tooltipPlacement="bottom-start"
                                            />
                                        )}
                                        {process.env.REACT_APP_HIDE_DOMAIN !== 'true' && item.allowGenericLogin && item.certificateSerialHash && (
                                            <RemoveCertificatesButton
                                                callback={discardCertificatesCallback}
                                                callbackParam={{ platformUser: item }}
                                                tooltipTitle="auth:certificate.discard_certificates"
                                                tooltipPlacement="bottom-start"
                                            />
                                        )}
                                    </>
                                )}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.id}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.username}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.personName}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.email}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.permissionGroup && item.permissionGroup.mainname}
                            </TableCell>
                            {process.env.REACT_APP_HIDE_DOMAIN !== 'true' && (
                                <TableCell classes={tableCellRoot} padding="none" align="left">
                                    {item.allowGenericLogin && <I18n trans={'general:common.no'} />}
                                    {!item.allowGenericLogin && <I18n trans={'general:common.yes'} />}
                                </TableCell>
                            )}
                            {process.env.REACT_APP_HIDE_DOMAIN !== 'true' && (
                                <TableCell classes={tableCellRoot} padding="none" align="left">
                                    {item.allowGenericLogin && item.certificateValidTo && DateHelperTs.format(item.certificateValidTo)}
                                </TableCell>
                            )}
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.allowGenericLogin && item.passwordLastChanged && DateHelperTs.format(item.passwordLastChanged)}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.allowGenericLogin && passwordExpiry && passwordExpiry.format('YYYY-MM-DD HH:mm:ss')}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.accountExpiration && DateHelper.format(item.accountExpiration)}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {!item.accountBlocked && <I18n trans={'general:common.no'} />}
                                {item.accountBlocked && <I18n trans={'general:common.yes'} />}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {!item.deleted && <I18n trans={'general:common.no'} />}
                                {item.deleted && <I18n trans={'general:common.yes'} />}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.allowGenericLogin && (
                                    <>
                                        {!item.singleLoginPassword && <I18n trans={'general:common.no'} />}
                                        {item.singleLoginPassword && <I18n trans={'general:common.yes'} />}
                                    </>
                                )}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.createdByPlatformUser && item.createdByPlatformUser.username}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {!item.systemAccount && <I18n trans={'general:common.no'} />}
                                {item.systemAccount && <I18n trans={'general:common.yes'} />}
                            </TableCell>
                        </TableRow>
                    );
                })}
            </TableBody>
        </React.Fragment>
    );
};
